import { useQuery } from '@tanstack/react-query';
import type { SsoProviderId, SsoProvidersResponse } from '@socialsoup/shared';
import { api } from '@/lib/api';

export const ssoProviderKeys = {
  all: ['auth', 'sso-providers'] as const,
};

/** The list only changes when the API's SSO env changes, i.e. on a deploy. */
const PROVIDERS_STALE_TIME_MS = 60 * 60 * 1000;

/**
 * The SSO providers the API has configured (sso-login Phase 4). The request is `public`:
 * it belongs to no session, so a stale stored bearer is not sent and a 401 cannot trigger a
 * refresh. While loading, and on any error, the list is empty, so the login page renders
 * exactly as it did before SSO and never breaks because of it.
 */
export function useSsoProviders(): SsoProviderId[] {
  const { data } = useQuery({
    queryKey: ssoProviderKeys.all,
    queryFn: async () => {
      const response = await api.get<SsoProvidersResponse>('/api/v1/auth/sso/providers', {
        public: true,
      });
      return response.data.providers;
    },
    staleTime: PROVIDERS_STALE_TIME_MS,
  });
  return data ?? [];
}
